import React from 'react';
import { SportsDisplayedContext } from '../../context/sportsDisplayed';
import { SportsDisplayedType } from '../../@types/sportsDisplayedType';
import { Convert, ITournamentRecap } from '../../interfaces/ITournamentRecap';
import TournamentRecap from '../../components/tournamentRecap/tournamentRecap';
import { GetFetchData } from '../../utility/fetch';

import '../../global.styles.scss';
import '../views.styles.scss';
import './blog.styles.scss';
import Tournament from '../../components/tournament/tournament';
import { ITournament } from '../../interfaces/ITournament';

interface IProps{}
interface IState{
    tournamentRecap: ITournamentRecap[];
}

export default class Blog extends React.Component<IProps, IState>{
    static contextType = SportsDisplayedContext;

    constructor (props: any){
        super(props);
       
        this.setTournamentData = this.setTournamentData.bind(this);
    }

    setTournamentData( data: string ){
        let tournamentData = Convert.toITournamentRecap( data );
        this.setState({ tournamentRecap: tournamentData });
    }

    componentDidMount(){
        GetFetchData( 'tournamentRecap', 'data/tournamentRecap.json', this.setTournamentData );
    }

    render(){
        const { isBaseballSelected, isSoftballSelected } = (this.context as SportsDisplayedType);

        const findTournamentYear = ( year: number ): ITournamentRecap | undefined => {
            let lsTournamentRecap = localStorage.getItem('tournamentRecap');
    
            if ( lsTournamentRecap !== undefined && lsTournamentRecap !== null ){
                let recapYears = Convert.toITournamentRecap( lsTournamentRecap );
                let tournamentYear: ITournamentRecap | undefined = recapYears.find( ry => ry.Year === year );
    
                return tournamentYear;
            } else {
                return undefined;
            }
        }

        const tournamentRecap2026: ITournamentRecap | undefined = findTournamentYear( 2026 );
        const tournamentRecap2025: ITournamentRecap | undefined = findTournamentYear( 2025 );
        const tournamentRecap2024: ITournamentRecap | undefined = findTournamentYear( 2024 );
        const tournamentRecap2023: ITournamentRecap | undefined = findTournamentYear( 2023 );
        const tournamentRecap2022: ITournamentRecap | undefined = findTournamentYear( 2022 );
        const tournamentRecap2021: ITournamentRecap | undefined = findTournamentYear( 2021 );
        const tournamentRecap2020: ITournamentRecap | undefined = findTournamentYear( 2020 );
        const tournamentRecap2019: ITournamentRecap | undefined = findTournamentYear( 2019 );

        const May2026Tournment: ITournament = {
            Title: 'Spring Tournament',
            Description: '',
            StartDate: { Date: 28, Month: 'April', Ordinal: 'th' },
            EndDate: { Date: 2, Month: 'May', Ordinal: 'nd' },
            Bracket: [
                {
                    Age: '10u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/1zLCRLB1vmHeuN6nTIPJG-tz10usFv73N_GEnPfuHb3I/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1JtB9wkxi1YH0hnPdwVD2qwTlFSdJ8ylw5VniPtvCyns/edit?usp=drive_link',
                    Results: ['LVC', 'Tremont']
                },
                  {
                    Age: '12u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/15CsINJCpHclAahGRGHNGVheIxr8jQJ3_udcmk68wFbQ/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1rTctvjuz8wKC9-bixo4CVUVP73WfoAB5TzmB_4PnXuk/edit?usp=sharing',
                    Results: ['1:9 Legacy', 'USA Prime Illinois Elliott']
                },
                {
                    Age: '13u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/1WdgHxgpZ1PZS8d2mCuDUCrV12P4KW6jlppUnaINYg7Y/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1g0n8zoCrIcXazWbe4j-eMrLM473RigvoZ_lUHB3gFzY/edit?usp=sharing',
                    Results: ['TCC Blue', 'TCC White']
                },
                {
                    Age: '14u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/19Jd3dJcUvhlQ7Ae2TgN0JuaLW3RbgJvL0YxAGQKOD78/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1E7JirQxJHTCdvIkJVrISKIVeLb3x-TlcS319XbT9MWI/edit?usp=sharing',
                    Results: ['OPBA', 'USA Prime Illinois Bruso']
                }
            ],
            Location: [
                {
                    Name: 'Central Junior High School',
                    MapsURL: 'https://www.google.com/maps/place/Central+Junior+High+School/@40.6642753,-89.5722625,19z/data=!4m5!3m4!1s0x880a5847d32fc4bf:0x7ce04b8d52c56a7c!8m2!3d40.6643549!4d-89.5717186',
                    City: 'East Peoria'
                },
                {
                    Name: 'Fondulac/Veterans Park',
                    City: 'East Peoria',
                    MapsURL: 'https://www.google.com/maps/place/Fondulac+Park,+East+Peoria,+IL+61611/@40.6576654,-89.5713119,17z/data=!3m1!4b1!4m2!3m1!1s0x880a58411a4da60f:0x7ef57a0ff5b244cf',
                    Notes: 'Turf batters box and mounds. METAL CLEATS ARE PROHIBITED!'
                },
                {
                    Name: 'Park District Sports Complex',
                    City: 'Pekin',
                    MapsURL: 'https://www.google.com/maps/place/Pekin+Park+Dist+Sports+Complex/@40.5525339,-89.6557469,17z/data=!3m1!4b1!4m5!3m4!1s0x880af477fff7ce11:0x94e9835b38fbcb06!8m2!3d40.5525341!4d-89.6535534'
                }
            ],
            Note: [
                'No open batting cages. Hitting into fence is prohibited.',
                'We ask coaches to turn in 3 game balls prior to your first game.'
            ]

        }

        return (
            <div className={`content-view blog ${ isBaseballSelected() ? 'showBaseball' : '' } ${ isSoftballSelected() ? 'showSoftball' : '' } `}>
                <article>
                    <header>2027 Tryouts</header>
                    
                    USA Prime Illinois Baseball will be hosting <strong>8-14u</strong> tryouts at <a href='https://www.google.com/maps/place/428+Taylor+St,+East+Peoria,+IL+61611/@40.6647004,-89.5758639,940m/data=!3m1!1e3!4m6!3m5!1s0x880a5848ae3289fd:0x8ed6b30632d9bfce!8m2!3d40.6646964!4d-89.573289!16s%2Fg%2F11dzp57jr0?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D' target='_blank' rel='noreferrer'>428 Taylor St</a> in East Peoria on
                    <ul>
                        <li>Sunday, July 12<sup>th</sup></li>
                        <li>Sunday, July 19<sup>th</sup></li>
                        <li>Sunday, July 26<sup>th</sup></li>
                    </ul>
                    <table className='table table-borderless table-75'>
                        <thead>
                            <tr><th scope='col' style={{width: '100px'}}>Age</th><th scope='col' style={{width: '150px'}}>Times</th><th scope='col'>Diamond</th></tr>
                        </thead>
                        <tfoot>
                            <tr><td colSpan={2}><a target='_blank' rel='noreferrer' href='https://forms.gle/PEmF9aSV1yW7AuCQ9'>8u - 14u Online Registration</a></td></tr>
                        </tfoot>
                        <tbody>
                            <tr><td>8u</td><td>12:00pm - 2:00pm</td><td>&#x23;3</td></tr>
                            <tr><td>9/10u</td><td>2:00pm - 4:00pm</td><td>&#x23;3</td></tr>
                            <tr><td>11/12u</td><td>2:00pm - 4:00pm</td><td>&#x23;1</td></tr>
                            <tr><td>13/14u</td><td>2:00pm - 4:00pm</td><td>&#x23;2</td></tr>
                        </tbody>
                    </table>

                    <hr/>

                    USA Prime Illinois Baseball will also be hosting <strong>15-18u</strong> tryouts at <a href='https://www.google.com/maps/place/Pekin+Park+Dist+Sports+Complex/@40.5523183,-89.6534513,942m/data=!3m1!1e3!4m15!1m8!3m7!1s0x880af387fc315c93:0xa0ee8c854b6984fe!2s300+Koch+St,+Pekin,+IL+61554!3b1!8m2!3d40.5525262!4d-89.6535908!16s%2Fg%2F11cnd809sz!3m5!1s0x880af477fff7ce11:0x94e9835b38fbcb06!8m2!3d40.552527!4d-89.6535567!16s%2Fg%2F11b7t45p49?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D' target='_blank' rel='noreferrer'>Pekin Park District Sports Complex</a> Pekin on
                    <ul>
                        <li>Wednesday, July 15<sup>th</sup></li>
                        <li>Saturday, August 1<sup>st</sup></li>
                        <li>Sunday, August 2<sup>nd</sup></li>
                        <li>Saturday, August 8<sup>th</sup></li>
                        <li>Sunday, August 9<sup>th</sup></li>
                    </ul>
                    <table className='table table-borderless table-75'>
                        <thead>
                            <tr><th scope='col' style={{width: '100px'}}>Age</th><th scope='col'>Times</th></tr>
                        </thead>
                        <tfoot>
                            <tr><td colSpan={2}><a target='_blank' rel='noreferrer' href='https://forms.gle/zi4QVGqeC9wZaWZe7'>15u - 18u Online Registration</a></td></tr>
                        </tfoot>
                        <tbody>
                            <tr><td>15/16u</td><td>5:00pm - 7:00pm</td></tr>
                            <tr><td>17/148u</td><td>3:00pm - 5:00pm</td></tr>
                        </tbody>
                    </table>                    

                    <p><span className='blue'><em>We have no residency restrictions</em></span>: any player is more than welcome to tryout regardless of where they live.</p>
                    <p>Please have all players "baseball ready": hats, gloves, bats, cleats, water, etc.</p>                    
                    <p className='text-muted'>Attendance is not required for all sessions, but being at multiple tryouts is encouraged.</p>
                    <p>Please contact Dave Hidden at 309.340.5251 if you are unable to make these dates or are interested in coaching.</p>
                </article>
                
                <Tournament {...May2026Tournment }/>
                <article>
                    <header>Spiritwear</header>
                    
                    <p>USA Prime Illinois appearal is now available via <a href='https://www.431sports.com/club/#/2006215261/fanwear' target='_blank' rel='noreferrer'> 431 Sports</a>.</p>  
                    <p>This is a traditional web store that doesn't have ordering windows, allowing you to purchase at your convenience.</p>

                </article>
                <TournamentRecap tournamentRecap={ tournamentRecap2026 }></TournamentRecap>
                
                {/* <article>
                    <header>Midwest Gamblers Is Now USA Prime Illinois!</header>
                    <img src='i/logo.png' alt='USA Prime logo' className='float-start' />
                    <p>Starting with the 2024 season, Midwest Gamblers will be joining the USA Prime national baseball program!</p>
                    <blockquote>"USA Prime brings a fantastic platform to the region to develop young players into leaders and ball players. I am excited to partner with USA Prime in Peoria to connect young players with the level of baseball that fits their skill set and to grow these players in all areas." ~ David Hidden.</blockquote>
                    <p>Established in 2017, USA Prime aims to prepare, develop, and mentor athletes to achieve their goals in baseball and ultimately reach their full potential.</p>
                </article> */}

                
                <TournamentRecap tournamentRecap={ tournamentRecap2025 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2024 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2023 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2022 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2021 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2020 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2019 }></TournamentRecap>
            </div>
        );
    } 
}